/**
 * Hero Slider with Clip-Path Animation
 */
class HeroSlider {
    constructor(selector) {
        this.slider = document.querySelector(selector);
        if (!this.slider) return;
        
        this.slides = this.slider.querySelectorAll('.hero-slider__slide');
        this.dots = this.slider.querySelectorAll('.hero-slider__dot');
        this.prevBtn = this.slider.querySelector('.hero-slider__prev');
        this.nextBtn = this.slider.querySelector('.hero-slider__next');
        
        this.currentSlide = 0;
        this.totalSlides = this.slides.length;
        this.isAnimating = false;
        this.autoplayInterval = null;
        this.autoplayDelay = 8000; // 8 sekund
        
        if (this.totalSlides === 0) {
            return;
        }
        
        this.init();
    }
    
    init() {
        this.setupSlides();
        this.bindEvents();
        this.startAutoplay();
    }
    
    setupSlides() {
        // Sprawdź czy mamy dokładnie 3 slajdy
        if (this.totalSlides !== 3) {
            return;
        }
        
        // Ustaw klasy początkowe dla slajdów
        this.slides.forEach((slide, index) => {
            slide.classList.remove('slide-0', 'slide-1', 'slide-2', 'slide-3', 'slide-4', 'current-1', 'current-2', 'current-3');
            
            if (index === 0) {
                slide.classList.add('slide-1', 'current-1'); // Pierwszy slajd na przodzie
                slide.dataset.originalIndex = '0';
            } else if (index === 1) {
                slide.classList.add('slide-2', 'current-2'); // Drugi slajd w środku  
                slide.dataset.originalIndex = '1';
            } else if (index === 2) {
                slide.classList.add('slide-3', 'current-3'); // Trzeci slajd z tyłu
                slide.dataset.originalIndex = '2';
            }
        });
        
        // Stwórz kopię slide-1 jako slide-4 (ukryty z prawej)
        this.createSlide4Copy();
        
        // Stwórz kopię slide-3 jako slide-0 (ukryty z lewej)
        this.createSlide0Copy();
        
        this.updateDots();
    }
    
    createSlide0Copy() {
        // Usuń poprzednią kopię jeśli istnieje
        const existingCopy = this.slider.querySelector('.slide-0-copy');
        if (existingCopy) {
            existingCopy.remove();
        }
        
        // Slide-0 jest zawsze kopią current-3
        const slide3 = this.slider.querySelector('.current-3');
        if (!slide3) {
            return;
        }
        
        // Sklonuj slajd current-3 z całą zawartością
        const slide0Copy = slide3.cloneNode(true);
        
        // Dodaj klasę identyfikacyjną i slide-0
        slide0Copy.classList.remove('slide-1', 'slide-2', 'slide-3', 'slide-4', 'current-1', 'current-2', 'current-3');
        slide0Copy.classList.add('slide-0', 'slide-0-copy');
        
        // Dodaj do kontenera na początku (żeby był z lewej strony)
        this.slider.querySelector('.hero-slider__slides').prepend(slide0Copy);
    }
    
    updateSlide0Copy() {
        // Aktualizuj slide-0 aby był kopią current-3
        const existingCopy = this.slider.querySelector('.slide-0-copy');
        if (existingCopy) {
            existingCopy.remove();
        }
        
        // Slide-0 jest zawsze kopią current-3
        const slide3 = this.slider.querySelector('.current-3');
        
        if (slide3) {
            const slide0Copy = slide3.cloneNode(true);
            slide0Copy.classList.remove('slide-1', 'slide-2', 'slide-3', 'slide-4', 'current-1', 'current-2', 'current-3');
            slide0Copy.classList.add('slide-0', 'slide-0-copy');
            
            this.slider.querySelector('.hero-slider__slides').prepend(slide0Copy);
        }
    }

    createSlide4Copy() {
        // Usuń poprzednią kopię jeśli istnieje
        const existingCopy = this.slider.querySelector('.slide-4-copy');
        if (existingCopy) {
            existingCopy.remove();
        }
        
        // Slide-4 jest zawsze kopią slide-1 (obecnego current-1)
        const slide1 = this.slider.querySelector('.current-1');
        if (!slide1) {
            return;
        }
        
        // Sklonuj slajd current-1 z całą zawartością
        const slide4Copy = slide1.cloneNode(true);
        
        // Dodaj klasę identyfikacyjną i slide-4
        slide4Copy.classList.remove('slide-1', 'slide-2', 'slide-3', 'current-1', 'current-2', 'current-3');
        slide4Copy.classList.add('slide-4', 'slide-4-copy');
        
        // Dodaj do kontenera
        this.slider.querySelector('.hero-slider__slides').appendChild(slide4Copy);
    }
    
    updateSlide4Copy() {
        // Aktualizuj slide-4 aby był kopią current-1
        const existingCopy = this.slider.querySelector('.slide-4-copy');
        if (existingCopy) {
            existingCopy.remove();
        }
        
        // Slide-4 jest zawsze kopią current-1
        const slide1 = this.slider.querySelector('.current-1');
        
        if (slide1) {
            const slide4Copy = slide1.cloneNode(true);
            slide4Copy.classList.remove('slide-1', 'slide-2', 'slide-3', 'current-1', 'current-2', 'current-3');
            slide4Copy.classList.add('slide-4', 'slide-4-copy');
            
            this.slider.querySelector('.hero-slider__slides').appendChild(slide4Copy);
        }
        
        // Sprawdź ile mamy slajdów po aktualizacji
        const allSlides = this.slider.querySelectorAll('.hero-slider__slide');
        allSlides.forEach((slide, index) => {
            const classes = Array.from(slide.classList).filter(c => c.includes('slide-') || c.includes('current-'));
        });
    }
    
    bindEvents() {
        // Nawigacja przyciskami
        this.nextBtn?.addEventListener('click', () => this.nextSlide());
        this.prevBtn?.addEventListener('click', () => this.prevSlide());
        
        // Nawigacja kropkami
        this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.goToSlide(index));
        });
        
        // Obsługa kliknięcia na slajdy
        this.addSlideClickHandlers();
        
        // Nawigacja klawiaturą
        document.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') this.prevSlide();
            if (e.key === 'ArrowRight') this.nextSlide();
        });
        
        // Obsługa touch/swipe
        this.addTouchSupport();
    }
    
    nextSlide() {
        if (this.isAnimating || this.totalSlides < 2) return;
        
        this.isAnimating = true;
        this.pauseAutoplay();
        
        // Animacja przejścia do następnego slajdu
        this.animateSlides('next');
        
        // Aktualizuj indeks
        this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
        
        setTimeout(() => {
            this.isAnimating = false;
            this.startAutoplay();
            // Aktualizuj kropki po zakończeniu animacji
            this.updateDots();
        }, 800);
    }
    
    prevSlide() {
        if (this.isAnimating || this.totalSlides < 2) return;
        
        this.isAnimating = true;
        this.pauseAutoplay();
        
        // Animacja przejścia do poprzedniego slajdu
        this.animateSlides('prev');
        
        // Aktualizuj indeks
        this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
        
        setTimeout(() => {
            this.isAnimating = false;
            this.startAutoplay();
            // Aktualizuj kropki po zakończeniu animacji
            this.updateDots();
        }, 800);
    }
    
    goToSlide(targetIndex) {
        if (this.isAnimating || targetIndex === this.currentSlide || this.totalSlides < 2) return;
        
        this.isAnimating = true;
        this.pauseAutoplay();
        
        // Oblicz najkrótszą drogę
        let stepsForward = (targetIndex - this.currentSlide + this.totalSlides) % this.totalSlides;
        let stepsBackward = (this.currentSlide - targetIndex + this.totalSlides) % this.totalSlides;
        
        const direction = stepsForward <= stepsBackward ? 'next' : 'prev';
        const steps = Math.min(stepsForward, stepsBackward);
        
        // Animuj odpowiednią liczbę kroków
        let currentStep = 0;
        const animateStep = () => {
            if (currentStep < steps) {
                this.animateSlides(direction);
                this.currentSlide = direction === 'next' 
                    ? (this.currentSlide + 1) % this.totalSlides
                    : (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
                currentStep++;
                
                // Aktualizuj kropki po każdym kroku
                this.updateDots();
                
                setTimeout(() => {
                    if (currentStep < steps) {
                        animateStep();
                    } else {
                        this.isAnimating = false;
                        this.startAutoplay();
                        // Upewnij się, że kropki są aktualne po zakończeniu
                        this.updateDots();
                    }
                }, 300);
            }
        };
        
        animateStep();
    }
    
    animateSlides(direction) {
        // Pobierz wszystkie slajdy włącznie z kopiami
        const allSlides = this.slider.querySelectorAll('.hero-slider__slide');
        
        if (direction === 'next') {
            // Najpierw zapisz obecne pozycje - sprawdzamy które slajdy są gdzie
            const slidePositions = [];
            allSlides.forEach(slide => {
                if (slide.classList.contains('slide-0') && !slide.classList.contains('slide-0-copy')) {
                    slidePositions.push({slide, currentPos: '0', newPos: 'hidden'});
                } else if (slide.classList.contains('slide-0-copy')) {
                    // slide-0-copy zostaje na miejscu
                    slidePositions.push({slide, currentPos: '0-copy', newPos: '0-copy'});
                } else if (slide.classList.contains('slide-1')) {
                    slidePositions.push({slide, currentPos: '1', newPos: '0'});
                } else if (slide.classList.contains('slide-2')) {
                    slidePositions.push({slide, currentPos: '2', newPos: '1'});
                } else if (slide.classList.contains('slide-3')) {
                    slidePositions.push({slide, currentPos: '3', newPos: '2'});
                } else if (slide.classList.contains('slide-4') && !slide.classList.contains('slide-4-copy')) {
                    slidePositions.push({slide, currentPos: '4', newPos: '3'});
                } else if (slide.classList.contains('slide-4-copy')) {
                    // slide-4-copy przechodzi w rotacji: slide-4-copy → slide-3
                    slidePositions.push({slide, currentPos: '4-copy', newPos: '3'});
                }
            });
            
            // Teraz przypisz nowe pozycje
            slidePositions.forEach(({slide, newPos}) => {
                // Usuń wszystkie klasy pozycji i current
                slide.classList.remove('slide-0', 'slide-1', 'slide-2', 'slide-3', 'slide-4', 'slide-0-copy', 'slide-4-copy', 'current-1', 'current-2', 'current-3');
                
                if (newPos === '0') {
                    slide.classList.add('slide-0');
                } else if (newPos === '0-copy') {
                    slide.classList.add('slide-0', 'slide-0-copy');
                } else if (newPos === '1') {
                    slide.classList.add('slide-1', 'current-1');
                } else if (newPos === '2') {
                    slide.classList.add('slide-2', 'current-2');
                } else if (newPos === '3') {
                    slide.classList.add('slide-3', 'current-3');
                } else if (newPos === 'hidden') {
                    // Slajd znika - można go usunąć po animacji
                    slide.style.display = 'none';
                    setTimeout(() => slide.remove(), 1000);
                }
            });
            
        } else {
            // Logika dla prev pozostaje podobna ale odwrócona
            const slidePositions = [];
            allSlides.forEach(slide => {
                if (slide.classList.contains('slide-0') && !slide.classList.contains('slide-0-copy')) {
                    slidePositions.push({slide, currentPos: '0', newPos: '1'});
                } else if (slide.classList.contains('slide-0-copy')) {
                    slidePositions.push({slide, currentPos: '0-copy', newPos: '0-copy'});
                } else if (slide.classList.contains('slide-1')) {
                    slidePositions.push({slide, currentPos: '1', newPos: '2'});
                } else if (slide.classList.contains('slide-2')) {
                    slidePositions.push({slide, currentPos: '2', newPos: '3'});
                } else if (slide.classList.contains('slide-3')) {
                    slidePositions.push({slide, currentPos: '3', newPos: '4'});
                } else if (slide.classList.contains('slide-4') && !slide.classList.contains('slide-4-copy')) {
                    slidePositions.push({slide, currentPos: '4', newPos: 'hidden'});
                } else if (slide.classList.contains('slide-4-copy')) {
                    slidePositions.push({slide, currentPos: '4-copy', newPos: '0'});
                }
            });
            
            slidePositions.forEach(({slide, newPos}) => {
                slide.classList.remove('slide-0', 'slide-1', 'slide-2', 'slide-3', 'slide-4', 'slide-0-copy', 'slide-4-copy', 'current-1', 'current-2', 'current-3');
                
                if (newPos === '0') {
                    slide.classList.add('slide-0');
                } else if (newPos === '0-copy') {
                    slide.classList.add('slide-0', 'slide-0-copy');
                } else if (newPos === '1') {
                    slide.classList.add('slide-1', 'current-1');
                } else if (newPos === '2') {
                    slide.classList.add('slide-2', 'current-2');
                } else if (newPos === '3') {
                    slide.classList.add('slide-3', 'current-3');
                } else if (newPos === '4') {
                    slide.classList.add('slide-4');
                } else if (newPos === 'hidden') {
                    slide.style.display = 'none';
                    setTimeout(() => slide.remove(), 1000);
                }
            });
        }
        
        // Po animacji aktualizuj kopie
        setTimeout(() => {
            this.updateSlide0Copy();
            this.updateSlide4Copy();
        }, 100);
    }
    
    updateDots() {
        this.dots.forEach((dot, index) => {
            const wasActive = dot.classList.contains('active');
            dot.classList.toggle('active', index === this.currentSlide);
            const isActive = dot.classList.contains('active');
        });
    }
    
    startAutoplay() {
        this.pauseAutoplay();
        this.autoplayInterval = setInterval(() => {
            this.nextSlide();
        }, this.autoplayDelay);
    }
    
    pauseAutoplay() {
        if (this.autoplayInterval) {
            clearInterval(this.autoplayInterval);
            this.autoplayInterval = null;
        }
    }
    
    addSlideClickHandlers() {
        // Dodaj obsługę kliknięcia na wszystkie slajdy
        this.slider.addEventListener('click', (e) => {
            // Znajdź najbliższy element slajdu
            const clickedSlide = e.target.closest('.hero-slider__slide');
            if (!clickedSlide || this.isAnimating) return;
            
            // Sprawdź czy to nie jest już aktywny slajd (slide-1)
            if (clickedSlide.classList.contains('slide-1')) return;
            
            // Sprawdź czy to jest slide-2 lub slide-3 (częściowo widoczne)
            if (clickedSlide.classList.contains('slide-2')) {
                // Kliknięto na slide-2 - przejdź do następnego
                this.nextSlide();
            } else if (clickedSlide.classList.contains('slide-3')) {
                // Kliknięto na slide-3 - przejdź dwa razy do następnego
                this.goToSlideFromPosition(2); // slide-3 to pozycja 2
            }
        });
    }
    
    goToSlideFromPosition(positionSteps) {
        if (this.isAnimating || this.totalSlides < 2) return;
        
        this.isAnimating = true;
        this.pauseAutoplay();
        
        // Animuj odpowiednią liczbę kroków do przodu
        let currentStep = 0;
        const animateStep = () => {
            if (currentStep < positionSteps) {
                this.animateSlides('next');
                this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
                currentStep++;
                
                // Aktualizuj kropki po każdym kroku
                this.updateDots();
                
                setTimeout(() => {
                    if (currentStep < positionSteps) {
                        animateStep();
                    } else {
                        this.isAnimating = false;
                        this.startAutoplay();
                        // Upewnij się, że kropki są aktualne po zakończeniu
                        this.updateDots();
                    }
                }, 300);
            }
        };
        
        animateStep();
    }
    
    addTouchSupport() {
        let startX = 0;
        let startY = 0;
        
        this.slider.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        }, { passive: true });
        
        this.slider.addEventListener('touchend', (e) => {
            const endX = e.changedTouches[0].clientX;
            const endY = e.changedTouches[0].clientY;
            
            const diffX = startX - endX;
            const diffY = startY - endY;
            
            // Sprawdź czy to poziomy swipe (nie przewijanie)
            if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
                if (diffX > 0) {
                    this.nextSlide();
                } else {
                    this.prevSlide();
                }
            }
        }, { passive: true });
    }
    
    // Publiczne metody
    destroy() {
        this.pauseAutoplay();
        
        // Zresetuj wszystkie slajdy do pozycji początkowych
        this.slides.forEach((slide, index) => {
            slide.classList.remove('slide-1', 'slide-2', 'slide-3', 'slide-4');
            slide.style.transform = '';
            slide.style.zIndex = '';
            slide.style.opacity = '';
        });
    }
    
    play() {
        this.startAutoplay();
    }
    
    pause() {
        this.pauseAutoplay();
    }
    
    refresh() {
        // Odśwież slider po zmianach w DOM
        this.slides = this.slider.querySelectorAll('.hero-slider__slide');
        this.dots = this.slider.querySelectorAll('.hero-slider__dot');
        this.totalSlides = this.slides.length;
        this.setupSlides();
    }
}

// Inicjalizacja po załadowaniu DOM
document.addEventListener('DOMContentLoaded', () => {
    const heroSlider = new HeroSlider('.hero-slider');
    
    // Udostępnij globalnie jeśli potrzeba
    if (heroSlider) {
        window.heroSlider = heroSlider;
    }
});

// Obsługa visibility API - zatrzymaj autoplay gdy karta nie jest aktywna
document.addEventListener('visibilitychange', () => {
    if (window.heroSlider) {
        if (document.hidden) {
            window.heroSlider.pause();
        } else {
            window.heroSlider.play();
        }
    }
});
